import './App.css';
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css";  // Import Slick's default CSS
import "slick-carousel/slick/slick-theme.css";  // Import Slick's theme CSS
import "./assets/css/style.css";
import "./assets/css/portfolio.css";
import "./assets/css/calculator.css";
import "./assets/css/responsive.css";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserLayout from './layouts/UserLayout';
import Home from './pages/Home'; 
import Calcutor from './pages/Calcutor';
function App() {
  return (
    <Router>
    <Routes>
     
      {/* Routes that use the UserLayout */}
      <Route path="/" element={<UserLayout />}>
        <Route index element={<Home />} /> 
      </Route> 
      <Route path='/calculator' element={<UserLayout/>}>
        <Route index element={<Calcutor/>} ></Route>
      </Route>
    </Routes>
  </Router>
  );
}

export default App;
